module.exports = __webpack_public_path__ + "static/media/news-hrch.5626de13.jpg";